// removed by extract-text-webpack-plugin
module.exports = {"prize":"Prize__prize___1-eVb","draggable":"Prize__draggable___3wB6h","isDragging":"Prize__isDragging___3DJSC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prizes/Prize.css
// module id = 327
// module chunks = 0